var React = require('react');

function Computer (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 14.4706C16.825 14.4706 17.4925 13.7824 17.4925 12.9412L17.5 4.52941C17.5 3.68824 16.825 3 16 3H4C3.175 3 2.5 3.68824 2.5 4.52941V12.9412C2.5 13.7824 3.175 14.4706 4 14.4706H1C1 15.3118 1.675 16 2.5 16H17.5C18.325 16 19 15.3118 19 14.4706H16ZM4 4.52941H16V12.9412H4V4.52941ZM10 15.2353C9.5875 15.2353 9.25 14.8912 9.25 14.4706C9.25 14.05 9.5875 13.7059 10 13.7059C10.4125 13.7059 10.75 14.05 10.75 14.4706C10.75 14.8912 10.4125 15.2353 10 15.2353Z","fill":"#A8ACB9"}));
}

Computer.defaultProps = {"viewBox":"0 0 20 20","fill":"none"};

module.exports = Computer;

Computer.default = Computer;
